export const createEventManager = () => {
  const cleanups = [];

  return {
    add: (target, eventName, handler, options) => {
      target.addEventListener(eventName, handler, options);
      cleanups.push(() =>
        target.removeEventListener(eventName, handler, options)
      );
    },
    cleanup: () => {
      cleanups.forEach((cleanup) => cleanup());
      cleanups.length = 0;
    },
  };
};
